<template>
   <div class="social-media">
        <h6>Share</h6>
        <share-network network="facebook" :url="currentUrl" :title="title" description="" hashtags="">
            <i class="icons8-facebook-f"></i>
        </share-network>
        <share-network network="linkedin" :url="currentUrl" :title="title">
            <i class="icons8-linkedin-2"></i>
        </share-network>
        <share-network network="twitter" :url="currentUrl" :title="title" hashtags="">
            <i class="icons8-twitter"></i>
        </share-network>
        <share-network network="email" :url="currentUrl" :title="title">
            <i class="icons8-new-post"></i>
        </share-network>
   </div>
</template>

<script>
import '@/plugins/vueSocialSharing.js';

export default {
    name: 'app-social-sharing',

    props: {
        title: {
            type: String,
            default: '',
        },

        url: {
            type: String,
            default: '',
        },
    },

    computed: {
        currentUrl() {
            return `${process.env.VUE_APP_URL}${this.url}`;
        },
    },
};
</script>

<style lang="scss" scoped>
    .social-media {
        display: flex;
        flex-direction: row;
        align-items: center;

        h6 {
            margin: 0 15px 0 0;
            text-transform: uppercase;
            font-size: 14px;
            font-weight: 700;
            color: #8e989f;
            margin-top: 10px;
            margin-bottom: 20px;
            letter-spacing: 1.4px;
            @include media-breakpoint-up(md) {
                margin: 0 30px 0 0;
            }
        }

        span {
            outline: none;
        }
    }
    .social-media i {
        color: #B5C0C7;
        font-size: 25px;
        margin-right: 15px;
        cursor: pointer;
        line-height: 0;
        outline: none;
        @include media-breakpoint-up(md) {
            margin-right: 30px;
        }
        &:hover {
            color: $primary;
        }
    }

     .social-media span {
        &:focus {
            outline: none;
        }
     }
</style>
